<div class="time-item">
    <div class="item-info">
        <div class="text-muted">{{TIME event_time}}</div>
        <p>
        {{#SWITCH item_type}}
        {{#CASE 'alarm_trigger'}}
            <i class="fa fa-bell error"></i> {{TR "Der Alarm"}} <strong>{{name}}</strong> {{TR "wurde ausgelöst."}}
            {{ALARM_NOTIFICATION}}
        {{/CASE}}
        {{#CASE 'alarm_ack'}}
            <i class="fa fa-check success"></i>
            {{#if by_current_user}}
            {{TR "Sie haben den Alarm"}} <strong>{{name}}</strong> {{TR "quittiert."}}
            {{else}}
            {{TR "Der Alarm"}} <strong>{{name}}</strong> {{TR "wurde quittiert."}}
            {{/if}}
        {{/CASE}}
        {{#CASE 'device_status'}}
            <i class="fa fa-exclamation-triangle warning"></i>
            {{TR "Der Status hat sich geändert"}}:
            <ul>
                {{#each errors}}
                    <li>{{text}}</li>
                {{/each}}
            </ul>
        {{/CASE}}
        {{#CASE 'device_ok'}}
            <i class="fa fa-check success"></i>
            {{TR "Der Status hat sich geändert"}}:
            <ul>
                {{#each errors}}
                    <li>{{text}}</li>
                {{/each}}
            </ul>
        {{/CASE}}
        {{#CASE 'device_reg'}}
            <i class="fa fa-info-circle"></i>
            {{TR "Das Gerät"}} <strong>{{name}}</strong> {{TR "wurde registriert"}}.
        {{/CASE}}
        {{#CASE 'device_seen'}}
            <i class="fa fa-info-circle"></i>
            {{TR "Das Gerät"}} <strong>{{name}}</strong> {{TR "hat sich zum letzten Mal gemeldet"}}.
        {{/CASE}}
        {{#CASE 'device_replacement'}}
            <i class="fa fa-exchange"></i>
            {{TR "Das Gerät wurde ausgetauscht"}}.
        {{/CASE}}
        {{#CASE 'device_grant_onsite_access'}}
            <i class="fa fa-key"></i>
            {{TR "Das Gerät wurde für die vor-Ort-Konfiguration freigegeben."}}
            {{#if custom_data}}
                <ul>
                    <li>{{TR "Anmerkung"}}: {{custom_data}}</li>
                </ul>
            {{/if}}
        {{/CASE}}
        {{#CASE 'meter_time_sync'}}
            <i class="fa fa-clock-o"></i>
            {{TR "Die Zählerzeit wurde synchronisiert."}}
            <ul>
                <li>{{TR "Abweichung"}}: {{custom_data}} {{TR "Stunden"}}</li>
            </ul>
        {{/CASE}}
        {{#CASE 'meter_time_anomaly'}}
            <i class="fa fa-exclamation-triangle error"></i>
            {{TR "Die Zählerzeitabweichung ist zu groß."}}
            <ul>
                <li>{{TR "Abweichung"}}: {{custom_data}} {{TR "Stunden"}}</li>
            </ul>
        {{/CASE}}
        {{#CASE 'create_backup'}}
            <i class="fa fa-download"></i>
            {{TR "Es wurde ein Backup der Konfiguration erstellt."}}
            {{#if custom_data}}
                <ul>
                    <li>{{TR "Anmerkung"}}: {{custom_data}}</li>
                </ul>
            {{/if}}
        {{/CASE}}
        {{#CASE 'restore_backup'}}
            <i class="fa fa-upload"></i>
            {{TR "Es wurde eine neue Konfiguration eingespielt."}}
            {{#if custom_data}}
                <ul>
                    <li>{{TR "Anmerkung"}}: {{custom_data}}</li>
                </ul>
            {{/if}}
        {{/CASE}}
        {{#CASE 'firmware_update'}}
            {{#SWITCH custom_data}}
                {{#CASE 'DONE'}}
                <i class="fa fa-upload"></i>
                {{TR "Ein Firmware Update wurde erfolgreich durchgeführt."}}
                {{/CASE}}
                {{#CASE undefined}}
                <i class="fa fa-exclamation-triangle error"></i>
                {{TR "Ein Firmware Update Versuch ist fehlgeschlagen."}}
                {{/CASE}}
            {{/SWITCH}}
        {{/CASE}}
        {{#CASE undefined}}
            <i class="fa fa-question-circle"></i>
            {{TR "Unbekanntes Ereignis"}}: <strong>{{item_type}}</strong>.
        {{/CASE}}
        {{/SWITCH}}
        </p>
        {{unknown}}
    </div>
</div>
